// stores/useParcoursCreator.js
import { cloneDeep, set as lodashSet } from 'lodash';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import api from '../config/axiosConfig';

export const useParcoursCreator = create(
  devtools(
    persist(
      (set, get) => ({
        // === ÉTAT FORMULAIRE (remplace react-hook-form partiel) ===
        formData: {
          nom: "Titre du parcours",
          description: "Description détaillée...",
          slug: "nom-parcours-2026",
          status: "draft",
          visibility: "private",
          niveau: "intermédiaire",
          dateLancement: new Date().toISOString().split("T")[0],
          dateFin: new Date(Date.now() + 240 * 24 * 60 * 60 * 1000).toISOString().split("T")[0], 
          dureeEstimee: 570,
          competences: [],
          pedagogicalObjectives: [],
          tags: [],
          categories: [],
          recompenses: {
            points: 0,
            badges: [],
            certificationTitle: ""
          },
          engineConfig: {
            isSequencial: true,
            allowSkipQuiz: false,
            enableDataHarvesting: true,
            autoValidateOpenQuestions: false,
            showContextualResources: true,
            progressionLogic: {
            weights: { quizzes: 40, activities: 30, capstone: 30 },
            minimumScoreToPass: 70
            }
          },
          modules: [
            {
            moduleId: "m1-critique-001",
            ordre: 1,
            nom: "Module 1", 
            titre: "Titre du module",
            description: "Description du module 1",
            objectifs: ["Apprendre les bases"], 
            status: "draft",
            duree: 240,
            dureeDetaillee: {
                contenu: 0,
                activités: 0, 
                quiz: 0
            },
            preActivityReflection: {
                text: "Texte de réflexion initiale de plus de 20 caractères...",
                questions: ["Question 1 ?"],
                duration: "10"
            },
            diagnosticQuiz: { title: "Diagnostic", questions: [], passingScore: 0 },
            granules: [
                {
                id: "g1-exemple",
                type: "scenario",
                titre: "Introduction",
                order: 1,
                duration: 5,
                content: {
                    steps: [],
                    comprehensionQuiz: { questions: [] },
                    mediatorOnFail: { type: "audio", path: "", description: "" }
                }
                },

                {
                type: "activity",
                titre: "...",
                description: "...",
                duration: 240,
                points: 180,
                order: 1,
                groupCollaboration: true,
                mediatorOnStart: [
                    {
                    type: "...",
                    path: "/chemin/audios",
                    description: "Message vocal d'accueil et/ou de guidage"
                    }
                ],
                objectifs: [
                    "Maîtriser l’analyse visuelle",
                    "Relier concrètement les concepts",
                    "Produire une analyse rigoureuse",
                    "Participer à une intelligence collective"
                ],
                comprehensionQuiz: {
                    title: "Validation théorique préalable",
                    passingScore: 80,
                    questions: [
                    {
                        text: "...",
                        type: "...",
                        points: 10
                    }
                    ]
                },
                fichier: {
                    type: "application/pdf",
                    path: "/uploads/pdf",
                    description: "..."
                },
                realTime: {
                    enabled: true,
                    wallTitle: "Mur vivant ",
                    wallDescription: "Partagez vos observations",
                    leaderboardEnabled: true,
                    streakEligible: true,
                    flashChallenge: {
                    active: true,
                    title: "Défi 48h",
                    description: "...",
                    bonusPoints: 40
                    },
                    instantFeedback: {
                    enabled: true,
                    maxDelayHours: 6,
                    mentorTags: [
                        "#validation",
                        "#question",
                        "#hypothèse",
                        "#lienpersonnel"
                    ]
                    },
                    welcomeMessage: {
                    content: "Bienvenue dans l’observatoire ",
                    isPinned: true
                    }
                },
                centralWorkspace: {
                    type: "visual-comparator",
                    config: {
                    title: "Observatoire",
                    images: [
                        {
                        url: "/images/example.jpg",
                        label: "..."
                        },
                        {
                        url: "/images/example.jpg",
                        label: "..."
                        }
                    ],
                    sliderEnabled: true,
                    annotationEnabled: true,
                    zoomEnabled: true,
                    gridOverlay: true
                    }
                },
                resources: {
                    steps: [
                    {
                        stepId: "1",
                        title: "...",
                        duration: 30,
                        type: "instruction",
                        text: "Utilisez la grille d'analyse."
                    }
                    ],
                    questions: [
                    {
                        text: "...",
                        type: "open"
                    }
                    ],
                    fileUploads: [
                    {
                        label: "...",
                        required: true,
                        accept: ".pdf",
                        maxSize: 40,
                        helpText: "..."
                    }
                    ],
                    validationSteps: [
                    {
                        stepId: "visual-quiz",
                        type: "quiz",
                        title: "... ",
                        passingScore: 85,
                        questions: [
                        {
                            text: "...",
                            type: "multiple-choice",
                            options: [ "..." ],
                            correct: 1
                        },
                        {
                            text: "Identifiez...",
                            type: "open",
                            maxLength: 300
                        },
                        {
                            text: "...",
                            type: "open"
                        }
                        ]
                    },
                    {
                        stepId: "mentor-feedback",
                        type: "mentor-feedback",
                        title: "Feedback mentor obligatoire",
                        instruction: "Envoyez votre PDF annoté..."
                    }
                    ],
                    liveSession: {
                    title: "Restitution collective",
                    date: "...",
                    time: "...",
                    link: "https://localhost:3000/video-call",
                    liveChat: true,
                    autoNotifyNewPost: true,
                    isLiveNow: false
                    }
                },
                alternativePath: {
                    type: "peer-discussion",
                    description: "Si accès impossible...",
                    validation: "..."
                }
                },
            ],
            fiches: [
                {
                id: crypto.randomUUID(),
                titre: "Fiche Théorique",
                filePath: "",
                fileType: "application/pdf",
                category: "theorie",
                sourceGranuleId: "",
                isConceptTool: true, // Crucial pour le store
                capabilities: ["read", "extract"] // Crucial pour les permissions de l'UI
                }
            ],
            interactiveResources: [],
            mediators: [],
            finalQuiz: { title: "Evaluation", questions: [], passingScore: 0 },
            }
          ],
          capstone: {
            moduleId: "",
            activityId: "",
            type: "capstone",
            titre: "Nouvelle Mission Capstone",
            description: "Décrivez l'impact attendu de cette mission finale.",
            duration: 2880,
            points: 2000,
            order: 999,
            groupCollaboration: true,
            
            // Audio d'accueil par défaut
            mediatorOnStart: [
            {
                type: "audio",
                path: "/audios/default-capstone-start.mp3",
                description: "Briefing initial de la mission."
            }
            ],

            objectifs: [
            "Synthétiser les acquis des modules",
            "Produire un impact réel sur le terrain",
            "Valider la posture de leader citoyen"
            ],

            resources: {
            steps: [
                {
                stepId: "step-1",
                type: "experiential-trigger",
                title: "Le Déclencheur",
                text: "Pourquoi cette cause est-elle votre priorité aujourd'hui ?",
                input: "vocal-preferred",
                placeholder: "Exprimez votre motivation profonde...",
                duration: 60,
                harvestKey: "motivation_initiale",
                required: true
                }
            ]
            },

            // Configuration par défaut du HUD / Zone centrale
            centralWorkspace: {
            type: "capstone-end",
            config: {
                title: "CENTRE DE COMMANDEMENT",
                timelineEnabled: true,
                impactMap: true,
                mediaWall: true,
                petitionTracker: true,
                leaderboardNational: true,
                flashChallenges: true
            }
            },

            // Configuration de la Sidebar Tactique
            realTime: {
            enabled: true,
            wallTitle: "FLUX OPÉRATIONNEL",
            wallDescription: "Partagez vos avancées en temps réel avec le réseau national.",
            flashChallenge: {
                active: false,
                title: "DÉPLOIEMENT RAPIDE",
                description: "Bonus de points pour les premières actions validées.",
                bonusPoints: 500
            },
            instantFeedback: {
                enabled: true,
                mentorTags: ["#impact", "#stratégie", "#urgence"]
            },
            welcomeMessage: {
                content: "Système prêt. En attente de vos premières directives sur le terrain.",
                isPinned: true
            }
            },

            // Finale Live
            liveSession: {
            title: "SESSION DE VALIDATION FINALE",
            date: "À définir",
            time: "20h00",
            link: "https://zoom.us/j/...",
            isLiveNow: false
            },
          },
          metadata: {
            version: "1.0",
            isTemplateLocked: false,
            author: "Admin"
          }
        },

        // === UI CREATOR (Navigation, tabs, etc.) ===
        ui: {
          currentProtocol: 1,
          activeModuleIdx: 0,
          isNavOpen: false,
          isSaving: false,
          isArchModalOpen: false
        },

        // === VALIDATION MÉTIER (Cross-Protocol) ===
        errors: {
          crossProtocol: null, // Pour tes règles métier (ex: weights !== 100%)
          zod: {}              // Erreurs Zod classiques
        },

        // === ACTIONS ===

        // Mise à jour du formulaire (remplace setValue de RHF)
        updateFormData: (path, value) => {
          set(state => {
            const newData = cloneDeep(state.formData);
            lodashSet(newData, path, value); // Gère tout automatiquement
            return { formData: newData };
          });
        },

        // Chargement template (remplace reset() de RHF)
        loadTemplate: (templateData) => {
          // Fonction utilitaire de normalisation de date
          const toDateInputValue = (value) => {
            if (!value) return value;
            const d = new Date(value);
            return isNaN(d.getTime()) ? value : d.toISOString().split('T')[0];
          };

          const normalized = {
            ...templateData,
            dateLancement: toDateInputValue(templateData.dateLancement),
            dateFin: toDateInputValue(templateData.dateFin),
          };

          set({ 
            formData: normalized,
            ui: { ...get().ui, currentProtocol: 1 }
          });
        },

        // Validation inter-protocoles (règle métier critique)
        validateCrossProtocol: () => {
          const { formData } = get();
          const weights = formData.engineConfig.progressionLogic.weights;
          const total = Object.values(weights).reduce((a, b) => a + b, 0);

          if (total !== 100) {
            set({ 
              errors: { 
                crossProtocol: `ERREUR CRITIQUE : Pondération = ${total}% (attendu 100%)` 
              }
            });
            return false;
          }

          if (!formData.modules?.length) {
            set({ 
              errors: { 
                crossProtocol: "Au moins 1 module requis" 
              }
            });
            return false;
          }

          set({ errors: { crossProtocol: null } }); // Clear errors
          return true;
        },

        // Normalisation pour Preview (fonction critique)
        normalizeForPreview: () => {
          const { formData } = get();
          
          return {
            ...formData,
            modules: formData.modules?.map(m => ({
              ...m,
              granules: m.granules?.map(g => {
                const isLab = g.type === 'activity';
                const steps = g.content?.steps || g.steps || [];

                return {
                  ...g,
                  id: g.id || `temp-${g.type}-${Math.random().toString(36).slice(2, 9)}`,
                  type: isLab ? 'activity' : 'scenario',
                  steps, // Position canonique (pour ScenarioPlayer)
                  resources: {
                    steps,
                    ...(isLab 
                      ? { questions: g.content?.questions || [] } 
                      : { media: g.content?.media }
                    )
                  },
                  // On garde content intact pour compatibilité
                  content: {
                    ...g.content,
                    steps // Duplication contrôlée (2 sources : scenario vs activity)
                  }
                };
              })
            }))
          };
        },

        // Sauvegarde (appel API)
        saveParcours: async () => {
          set(state => ({ ui: { ...state.ui, isSaving: true } }));

          const { formData, validateCrossProtocol } = get();

          if (!validateCrossProtocol()) {
            set(state => ({ ui: { ...state.ui, isSaving: false } }));
            throw new Error(get().errors.crossProtocol);
          }

          try {
            const { data } = await api.post('/generic-parcours/create', formData);
            const { slug } = data;

            set(state => ({ ui: { ...state.ui, isSaving: false } }));
            return slug;   // ✅ Redirection possible tout de suite
          } catch (err) {
            set(state => ({ ui: { ...state.ui, isSaving: false } }));
            throw err;
          }
        },

        // Preview 
        handlePreview: (level) => {
          const normalized = get().normalizeForPreview();
          
          // Sauvegarde locale (comme avant)
          localStorage.setItem('PESA_PREVIEW_DATA', JSON.stringify(normalized));

          // Routing (inchangé)
          const slug = normalized.slug || "draft-preview";
          const routes = {
            parcours: `/parcours/${slug}`,
            module: `/investigation/${slug}`,
            activity: `/investigation/${slug}/lab/${normalized.modules?.[0]?.granules?.[0]?.id}`
          };

          const url = new URL(window.location.origin + (routes[level] || routes.parcours));
          url.searchParams.set('preview', 'true');
          if (level === 'activity') url.searchParams.set('autoOpenLab', 'true');

          window.open(url.toString(), '_blank');
        },

        // Navigation UI
        setProtocol: (id) => set(state => ({ ui: { ...state.ui, currentProtocol: id } })),
        setActiveModule: (idx) => set(state => ({ ui: { ...state.ui, activeModuleIdx: idx } })),
        
        toggleNav: () => set(state => ({ ui: { ...state.ui, isNavOpen: !state.ui.isNavOpen } })),
        toggleArchModal: () => set(state => ({ ui: { ...state.ui, isArchModalOpen: !state.ui.isArchModalOpen } }))
      }),
      {
        name: 'parcours-creator-storage', // Clé localStorage
        partialize: (state) => ({ formData: state.formData }), // Seul formData est persisté
      }
    ),
    { name: 'PESA-PARCOURS-CREATOR' }
  )
);